module.exports = __webpack_public_path__ + "054d9b5e2f6c47bfa994b0af94dffc96.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_10.jpg
// module id = 630
// module chunks = 0